/**
 * Normalizează eroarea axios într-un string sigur pentru `toast.error`.
 * FastAPI returnează pentru 422 un array de obiecte Pydantic
 * `[{loc:[...], msg:"...", type:"..."}, ...]`, iar trimiterea acestuia
 * direct la React/sonner aruncă „Objects are not valid as a React child".
 *
 * Utilizare:
 *   import { errMsg } from "../lib/apiErrors";
 *   try { ... } catch (e) { toast.error(errMsg(e)); }
 */
export function errMsg(err, fallback = "Eroare") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    // FastAPI validation error array
    return detail
      .map((d) => {
        if (typeof d === "string") return d;
        if (d?.msg) {
          const loc = Array.isArray(d.loc) ? d.loc.filter((p) => p !== "body").join(".") : "";
          return loc ? `${loc}: ${d.msg}` : d.msg;
        }
        return JSON.stringify(d);
      })
      .join("; ");
  }
  if (typeof detail === "object") {
    if (detail.msg) return String(detail.msg);
    try { return JSON.stringify(detail); } catch { return fallback; }
  }
  return String(detail);
}
